import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import {initJivo} from '@/utils/jivo'
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import {definePreset} from '@primevue/themes';

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{indigo.50}',
            100: '{indigo.100}',
            200: '{indigo.200}',
            300: '{indigo.300}',
            400: '{indigo.400}',
            500: '{indigo.500}',
            600: '{indigo.600}',
            700: '{indigo.700}',
            800: '{indigo.800}',
            900: '{indigo.900}',
            950: '{indigo.950}'
        }
    }
});

const localRu = require('@/assets/primevue-ru.json')

initJivo()

createApp(App).use(router).use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            darkModeSelector: false
        }
    },
    locale: localRu.ru,
    zIndex: {
        overlay: 2000,      //select, popover
    }
}).mount('#app')
